<template>
  <div>
    <ConfirmationDialog
      ref="confirmDialog"
      cancel-label="no, keep resource"
      confirm-label="Yes, delete"
      confirm-btn-type="danger"
    />

    <ProviderShowHeader
      :tabs="tabs"
      :provider="vendor"
      :create-data="createData"
      @delete="onDeleteVendor"
      @update-field="updateField"
    />
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapActions, mapState } from 'vuex'
// Mixins
import { registerVuexModule } from '@/mixins/register-vuex-module'
// Components
import ConfirmationDialog from '@/ui/ConfirmationDialog'
import ProviderShowHeader from '@/reusable/provider-show-header/ProviderShowHeader'

export default {
  components: {
    ConfirmationDialog,
    ProviderShowHeader
  },

  mixins: [registerVuexModule('vendor-show', () => require('./vuex/VendorShow'))],

  props: {
    id: [Number, String] // from route
  },

  data() {
    return {
      tabs: [
        {
          id: 1,
          name: 'Subscriptions',
          route: `/vendors/${this.id}/subscriptions`
        },
        {
          id: 2,
          name: 'Notes & Tasks',
          route: `/vendors/${this.id}/notes-tasks`
        },
        {
          id: 3,
          name: 'Orders & Invoices',
          route: `/vendors/${this.id}/orders-invoices`
        },
        { id: 4, name: 'Contacts', route: `/vendors/${this.id}/contacts` },
        { id: 5, name: 'Addresses', route: `/vendors/${this.id}/addresses` },
        { id: 6, name: 'Metadata', route: `/vendors/${this.id}/meta-data` }
      ]
    }
  },

  computed: {
    ...mapState('vendor-show', ['vendor', 'createData'])
  },

  created() {
    this.initData(this.id)
  },

  methods: {
    ...mapActions('vendor-show', ['updateField', 'initData']),

    onDeleteVendor() {
      apiTo.GET_VENDOR_DELETE_CONFIRMATION(this.id).then(({ data }) => {
        const dialog = this.$refs.confirmDialog.show({
          title: data.messages.default.join('\n') || ' Are you sure you want to delete this vendor?',
          noConfirm: !data.result.deletable,
          noCancel: !data.result.deletable,
          persistent: data.result.deletable
        })

        dialog.onCancel(hide => hide())
        dialog.onConfirm((hide, setLoading) => {
          setLoading()
          apiTo
            .DELETE_VENDOR(this.id)
            .then(() => this.$router.replace({ path: '/vendors' }))
            .catch(() => hide())
        })
      })
    }
  }
}
</script>
